
import React, { Fragment, useState } from 'react'
import { Col, Form, Row } from 'react-bootstrap'
import moment from 'moment'
import Swal from 'sweetalert2'
import { useDispatch } from 'react-redux'

import useTranslation from '@/Hooks/UseTranslation'
import { useProgrammation } from '@/Hooks/UseProgrammation'
import { useProject } from '@/Hooks/UseProject'

import { updateTaskAction, updateTaskDateAction } from '@/Redux/Actions/ProgrammationManagerActions'
import { updateTaskScheduledDates } from '@/Services/ProgrammationManagerService'

import InputDate from '../../components/InputDate'
import InputDateRange from '../../components/InputDateRange/InputDateRange'
import InputText from '../../components/InputText'

const TaskScheduledDates = () => {

  const { t } = useTranslation()

  const dispatch = useDispatch()

  const { itemOpened: task, patchItemOpened, setEditingItem } = useProgrammation()
  const { project, nonWorkingDays } = useProject()

  const [ startsAt, setStartsAt ] = useState(moment(task.startsAt).format('YYYY-MM-DD'))
  const [ endsAt, setEndsAt ] = useState(moment(task.endsAt).format('YYYY-MM-DD'))
  const [ updating, setUpdating ] = useState(false)
  const [ startError, setStartError ] = useState<string>('')
  const [ endError, setEndError ] = useState<string>('')
  const [ showDatePicker, setShowDatePicker ] = useState(false)

  const saveChanges = async (startsAt: string, endsAt: string) => {
    setUpdating(true)
    setEditingItem(true)

    const [ error, data ] = await updateTaskScheduledDates(task._id, startsAt, endsAt)

    setUpdating(false)
    setEditingItem(false)

    if (error) {
      return false
    }

    patchItemOpened({
      startsAt: data.task.startsAt,
      endsAt: data.task.endsAt,
      executeDays: data.task.executeDays,
    })

    await dispatch(updateTaskAction(data.task, data.updatedTasks))
  }

  // const handleChangeStartsAtDate = (date: string) => {

  //   setStartError('')
  //   setEndError('')

  //   const day = moment(date, 'YYYY-MM-DD')
  //   const projectStartsAt = moment(project.startsAt, 'YYYY-MM-DD')
  //   const projectEndsAt = moment(project.endsAt, 'YYYY-MM-DD')

  //   const startIsBeforeProjectStart = day.isBefore(projectStartsAt, 'd')
  //   const startIsAfterProjectEnd = day.isAfter(projectEndsAt, 'd')
  //   const isBadDate = startIsBeforeProjectStart || startIsAfterProjectEnd

  //   if (isBadDate) {

  //     Swal.fire({
  //       title: t('ERROR:BadDate'),
  //       text: t('PROGRAMMATION_MANAGER:DateCanNotBeLowerThanProjectError'),
  //       icon: 'error',
  //       confirmButtonText: t('ERROR:CloseButton'),
  //       width: '400px',
  //     })

  //     return false
  //   }

  //   setStartsAt(date)

  //   let endDay = moment(task.endsAt, 'YYYY-MM-DD HH:mm:ss')

  //   if (day.isAfter(endDay, 'd')) {

  //     endDay = day

  //     setEndsAt(endDay.format('YYYY-MM-DD'))
  //   }

  //   saveChanges(date, endDay.format('YYYY-MM-DD'))
  // }

  // const handleChangeEndsAtDate = (date: string) => {

  //   setStartError('')
  //   setEndError('')

  //   const day = moment(date, 'YYYY-MM-DD')
  //   const projectStartsAt = moment(project.startsAt, 'YYYY-MM-DD')
  //   const projectEndsAt = moment(project.endsAt, 'YYYY-MM-DD')

  //   const endIsBeforeProjectStart = day.isBefore(projectStartsAt, 'd')
  //   const endIsAfterProjectEnd = day.isAfter(projectEndsAt, 'd')
  //   const isBadDate = endIsBeforeProjectStart || endIsAfterProjectEnd

  //   if (isBadDate) {

  //     Swal.fire({
  //       title: t('ERROR:BadDate'),
  //       text: t('PROGRAMMATION_MANAGER:DateCanNotBeLowerThanProjectError'),
  //       icon: 'error',
  //       confirmButtonText: t('ERROR:CloseButton'),
  //       width: '400px',
  //     })

  //     return false
  //   }

  //   setEndsAt(date)

  //   let startDay = moment(task.startsAt, 'YYYY-MM-DD HH:mm:ss')

  //   if (day.isBefore(startDay, 'd')) {

  //     startDay = day

  //     setStartsAt(startDay.format('YYYY-MM-DD'))
  //   }

  //   saveChanges(startDay.format('YYYY-MM-DD'), date)
  // }

  const handleChangeDates = (dates: any) => {

    const {
      startsAt,
      endsAt
    } = dates

    setStartError('')
    setEndError('')

    setStartsAt(startsAt)
    setEndsAt(endsAt)

    saveChanges(startsAt, endsAt)

    setShowDatePicker(false)
  }

  return (
    <>
      <Row>
        <Col sm={4}>
          <Form.Group>
            <Form.Label>
              {t('PROGRAMMATION_MANAGER:StartsAtLabel')}
            </Form.Label>
            <InputDate
              value={startsAt}
              placeholder="dd/mm/yyyy"
              readonly
              invalid={!!startError}
              onClick={() => setShowDatePicker(true)}
              disabled={task.progress > 0}
              asButton
            />
          </Form.Group>
        </Col>
        <Col sm={4}>
          <Form.Group>
            <Form.Label>
              {t('PROGRAMMATION_MANAGER:EndsAtLabel')}
            </Form.Label>
            <InputDate
              value={endsAt}
              placeholder="dd/mm/yyyy"
              readonly
              invalid={!!endError}
              onClick={() => setShowDatePicker(true)}
              disabled={task.progress > 0}
              asButton
            />
          </Form.Group>
        </Col>
        <Col sm={4}>
          <Form.Group>
            <Form.Label>
              {t('PROGRAMMATION_MANAGER:ExecuteDaysLabel')}
            </Form.Label>
            <InputText
              value={task.executeDays}
              disabled
            />
          </Form.Group>
        </Col>
      </Row>
      {showDatePicker && (
        <Row>
          <Col>
            <InputDateRange
              startsAt={startsAt}
              endsAt={endsAt}
              projectStartDate={project.startsAt}
              projectEndDate={project.endsAt}
              nonWorkingDays={nonWorkingDays}
              onChange={handleChangeDates}
              onCancel={() => setShowDatePicker(false)}
            />
          </Col>
        </Row>
      )}
    </>

  )
}

export default TaskScheduledDates
